module.exports = __webpack_public_path__ + "img/reading-a-book.a8c52b1e.svg";